import React from 'react';
import PropTypes from 'prop-types';

class RegexpInput extends React.Component {
  static propTypes = {
    pattern: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    inputRef: PropTypes.func,
    type: PropTypes.string,
  };
  static defaultProps = {
    pattern: '',
    value: undefined,
    inputRef: undefined,
    onChange: () => {},
    type: 'text',
  };

  handleChange = e => {
    const { value } = e.target;
    const { pattern, onChange } = this.props;

    if (value.match(pattern) || value === '') {
      onChange(value);
    }
  };

  render() {
    const { onChange, inputRef, type, ...props } = this.props;
    return <input type={type} onChange={this.handleChange} ref={inputRef} {...props} />;
  }
}

export default RegexpInput;



// WEBPACK FOOTER //
// ./src/shared/components/RegexpInput/RegexpInput.js